// extracted by css-extract-rspack-plugin
export default {"root":"I02Whqqrzm0UGBit","fade-in":"VqqykBIDXAA6SM2I","icon":"aX4CFXAnyegQO44n"};